// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"85f4f016","206":"0c74264a","361":"c525dd66","399":"1a6f8c52","438":"6a9436d0","453":"7460c7ab","482":"ee4ce210","485":"1331ae22","536":"420161ce","605":"ba67f3a8","608":"0a0ac4e7","689":"54489c24"}[chunkId] + ".chunk.js";
};